import React from "react";

import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import About from '../pages/about';
import Gallery from '../pages/gallery';
import Home from '../pages/home';
import Access from '../pages/access';

const AppNavigation = () => {
	return (
		<Router>
			<Switch>
				<Route path="/about">
					<About />
				</Route>
				<Route path="/gallery">
					<Gallery />
				</Route>
				<Route path="/access">
					<Access />
				</Route>
				<Route path="/">
					<Home />
				</Route>
			</Switch>
		</Router>
	)
}

export default AppNavigation;